// "98765 43210", "+91 98765-43210", "09876543210" -> "9876543210"; null when it isn't a valid
// 10-digit Indian mobile. Mirrors PhoneNumberUtil#normalizeIndianMobile on the backend, so the
// popups reject exactly what the server would.
export const normalizeMobile = (raw) => {
  let digits = String(raw || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  return /^[6-9]\d{9}$/.test(digits) ? digits : null;
};
